import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function GrowthForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [headCircumference, setHeadCircumference] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!weight && !height && !headCircumference) return;

    onAdd({
      date: new Date(date).toISOString(),
      weight: weight || null,
      height: height || null,
      headCircumference: headCircumference || null,
      type: "growth",
      notes: notes || "",
    });

    setDate(toDatetimeLocal());
    setWeight("");
    setHeight("");
    setHeadCircumference("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Weight (lbs)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g. 15.5"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            step="0.1"
            min="0"
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Height (inches)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g. 28.5"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            step="0.1"
            min="0"
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Head Circumference (inches)</label>
          <input
            type="number"
            className="form-control"
            placeholder="e.g. 17.2"
            value={headCircumference}
            onChange={(e) => setHeadCircumference(e.target.value)}
            step="0.1"
            min="0"
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button type="submit" className="btn btn-success w-100">
            Add Measurement
          </button>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-12">
          <textarea
            className="form-control form-control-sm"
            placeholder="Add a note..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={2}
            style={{ resize: "none" }}
          />
        </div>
      </div>
    </form>
  );
}
